export function checkPreviewFlag(obj) {
  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      typeof obj[key] === "object" &&
      obj[key] !== null &&
      obj[key].isPreview === true
    ) {
      return true;
    }
  }
  return false;
}
